import React, { useState } from "react";
import { Card, Button, Upload, Table, message } from "antd";
import { UploadOutlined, DownloadOutlined } from "@ant-design/icons";
import axiosNew from "../../store/api/axiosNew";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { fetchAdminAllLeads } from "../../store/action/admin/NewDashboardAction";
import { useDispatch } from "react-redux";

const BulkUploadLeads = () => {
  const [file, setFile] = useState(null);
  const [previewData, setPreviewData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  /* ===============================
     Download sample excel
  =============================== */
  const downloadSample = async () => {
    try {
      const res = await axiosNew.get("/admin/leads/template/sample-excel", {
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.download = "sample_leads.xlsx";
      link.click();
      window.URL.revokeObjectURL(url);
    } catch {
      message.error("Failed to download sample");
    }
  };

  /* ===============================
     Read excel & preview
  =============================== */
  const handleFileChange = (info) => {
    const uploadedFile = info.file; // ✅ FIXED
    console.log("File:", info.file);

    if (!uploadedFile) return;

    setFile(uploadedFile);

    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];

        const jsonData = XLSX.utils.sheet_to_json(sheet, {
          defval: "", // ✅ prevents undefined cells
        });

        if (!jsonData.length) {
          message.warning("Excel file is empty");
          setPreviewData([]);
          return;
        }

        // Dynamic columns
        const tableColumns = Object.keys(jsonData[0]).map((key) => ({
          title: key,
          dataIndex: key,
          key,
        }));

        setColumns(tableColumns);
        setPreviewData(jsonData);
      } catch (err) {
        console.error(err);
        message.error("Invalid Excel file");
      }
    };

    reader.readAsArrayBuffer(uploadedFile);
  };

  /* ===============================
     Upload excel to backend
  =============================== */
  const handleUpload = async () => {
    if (!file) {
      message.warning("Please select a file");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      setLoading(true);

      const res = await axiosNew.post("/admin/leads/bulk-upload/", formData);

      message.success(res.data.message || "Leads uploaded successfully");
      await dispatch(fetchAdminAllLeads());
      // Optional: refresh dashboard data
      navigate("/admin/retail-admin-dashboard", { replace: true });
    } catch (err) {
      console.error(err);
      message.error(err?.response?.data?.message || "Upload failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card
      title="Bulk Upload Leads"
      style={{ maxWidth: 1100, margin: "20px auto" }}
      extra={
        <Button icon={<DownloadOutlined />} onClick={downloadSample}>
          Download Sample Excel
        </Button>
      }
    >
      <Upload
        beforeUpload={() => false}
        onChange={handleFileChange}
        maxCount={1}
        showUploadList={false}
        accept=".xlsx,.xls"
      >
        <Button icon={<UploadOutlined />}>Select Excel File</Button>
      </Upload>

      {/* ===============================
         Excel Preview Table
      =============================== */}
      {previewData.length > 0 && (
        <>
          <h4 style={{ marginTop: 20 }}>Excel Preview</h4>

          <Table
            columns={columns}
            dataSource={previewData}
            rowKey={(_, index) => index}
            scroll={{ x: "max-content" }}
            pagination={{ pageSize: 10 }}
            bordered
          />

          <div style={{ textAlign: "center", marginTop: 20 }}>
            <Button type="primary" loading={loading} onClick={handleUpload}>
              Upload Leads
            </Button>
          </div>
        </>
      )}
    </Card>
  );
};

export default BulkUploadLeads;
